<script>
  import { duplicateIcon } from "../../../Utils/utilConstants.svelte";

  import { copyObjContent } from "../../../Utils/utilFunctions.svelte";

  import { CardLayout } from "../index.svelte";

  export let request = "";

  let isRequestInJson;

  if (request) {
    try {
      JSON.parse(request);
      isRequestInJson = true;
    } catch (err) {
      isRequestInJson = false;
    }
  }

  $: btnOptions = [
    {
      iconName: "copyIcon",
      iFont: duplicateIcon,
      hasTooltip: true,
      tooltip: "Copy content",
      iconFunction: () =>
        copyObjContent(
          isRequestInJson ? JSON.parse(request) : request,
          "Request Copied!",
        ),
      isHidden: !request,
    },
  ];
</script>

<CardLayout title="Request" {btnOptions}>
  <div class="flex flex-col p-2 w-full gap-y-3">
    <div class="flex flex-row gap-x-2">
      {#if request}
        {#if isRequestInJson}
          <pre
            class="whitespace-pre-wrap font-sans break-words">{JSON.stringify(
              JSON.parse(request),
              undefined,
              2,
            )}</pre>
        {:else}
          <p class="whitespace-pre-wrap break-all font-sans">
            {request}
          </p>
        {/if}
      {:else}
        <p>No request</p>
      {/if}
    </div>
  </div>
</CardLayout>
